import '../App.css';
//import './fonts/WinterKei.css';
import teams from '../config/teams.json'
import { Bar1002v2 } from '../components/Bar100-2v2';
import ChartjsPluginStacked100 from "chartjs-plugin-stacked100";
import ChartjsPluginAnnotation from "chartjs-plugin-annotation";

import { useState, useEffect } from 'react';
import { socket } from '../socket';
import { useSocketEvent, useSocketState } from '../helpers/useSocket';

import { convertSummary } from '../helpers/convertSummary'
import { fancyTimeFormat } from '../helpers/fancyTimeFormat'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Scatter, Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ChartjsPluginStacked100,
  ChartjsPluginAnnotation,
);

function ScoreRow({ players, index, item }) {
  const highestValue = Math.max(...players.map(player => player[item]))
  const lowestValue = Math.min(...players.map(player => player[item]))

  return (<td className="px-6 py-4 text-white">
    {players[index][item]}
    {item == "economyLost" ?
      players[index][item] == lowestValue && <span className='text-yellow-400'>⭐</span>
      :
      players[index][item] == highestValue && <span className='text-yellow-400'>⭐</span>
    }
  </td>);
}

function getTeamNameByPlayer(playerName) {
  //console.log(teams[0].players.includes(playerName))
  for (const team of teams) {
    console.log(team)
    if (team.players.includes(playerName)) {
      return team.teamName
    }
  }
  return playerName
}

export default function Display2v2() {

  const [isConnected, setIsConnected] = useState(socket.connected);
  const [data, setData] = useState()
  const [militaryLead, setMilitaryLead] = useState()
  const [summary, setSummary] = useState({})
  const [config, setConfig] = useState({});

  const [annotations, setAnnotations] = useState([])

  const [isReady, setIsReady] = useState(false)

  const [player1Class, setPlayer1Class] = useState('')
  const [player2Class, setPlayer2Class] = useState('')

  const [extraInfo, setExtraInfo] = useState({})
  const [match] = useSocketState('Match')

  useSocketEvent('updateCurrent', (newdata) => {
    setData(newdata.summary)
    setExtraInfo(newdata.extra)
  })

  useSocketEvent('updateConfig', (newdata) => {
    console.log(`Received updateConfig`, newdata);
    setConfig(newdata)
  })

  useEffect(() => {
    console.log("socketemit registerPostgame")
    socket.emit('registerPostgame');
  }, []);

  var loserClass = "text-gray-400"
  var winnerClass = "text-white"

  const colors = ["#4A88ED", "#82b1f2", "#f58080", "#f04343"]
  const ageMarkerOffset = ["5%", "15%", "100%", "85%"]

  useEffect(() => {
    if (!data || !data.players || !match) {
      setIsReady(false)
      return;
    }

    if (!data) return;

    let _summary = convertSummary(data);

    let _annotations = []

    console.log(_summary)


    //Check if the game is a 2v2
    if (_summary && _summary?.players.length === 4) {
      //console.log(_summary.players[1].name)

      //Sort by win to get the teams on 0,1 and 2,3
      _summary.players.sort((a, b) => String(a.result).localeCompare(String(b.result)))

      //Swap the teams around if extra info wants it
      if (_summary.players[2].name === extraInfo.leftPlayer || _summary.players[3].name === extraInfo.leftPlayer) {
        _summary.players = [_summary.players[2], _summary.players[3], _summary.players[0], _summary.players[1]]
      }
    }

    //jank fix on this, shouldn't check here if it's a 1v1 or 2v2 really, but eh
    // Swap players if extrainfo wants it
    if (_summary && _summary?.players.length === 2 && _summary.players[1].name === extraInfo.leftPlayer) {
      _summary.players = [_summary.players[1], _summary.players[0]]
    }

    _summary?.players.forEach((player, index) => {
      if (player.feudalAge) {
        _annotations.push({
          type: 'line',
          scaleID: 'x',
          value: player.feudalAge,
          borderColor: colors[index],
          borderWidth: 4,
          borderDash: [4, 4],
          label: {
            display: true,
            backgroundColor: 'rgba(0,0,0,0.1)',
            color: colors[index],
            position: ageMarkerOffset[index],
            font: { size: 20 },
            padding: { left: 4, top: 4, right: 4, bottom: 2 },
            content: age2img
          }
        });
      }
      if (player.castleAge) {
        _annotations.push({
          type: 'line',
          scaleID: 'x',
          value: player.castleAge,
          borderColor: colors[index],
          borderWidth: 4,
          borderDash: [4, 4],
          label: {
            display: true,
            backgroundColor: 'rgba(0,0,0,0.1)',
            color: colors[index],
            position: ageMarkerOffset[index],
            font: { size: 20 },
            padding: { left: 4, top: 4, right: 4, bottom: 2 },
            content: age3img,
          }
        });
      }
      if (player.imperialAge) {
        _annotations.push({
          type: 'line',
          scaleID: 'x',
          value: player.imperialAge,
          borderColor: colors[index],
          borderWidth: 4,
          borderDash: [4, 4],
          label: {
            display: true,
            backgroundColor: 'rgba(0,0,0,0.1)',
            color: colors[index],
            position: ageMarkerOffset[index],
            font: { size: 20 },
            padding: { left: 4, top: 4, right: 4, bottom: 2 },
            content: age4img
          }
        });
      }
    });

    //setMilitaryLead(_summary?.players[0].timeline.map((v, i) => ({ x: v.time, y: v.score_military - _summary?.players[1].timeline[i].score_military })))
    const weights = [1, 1, -1, -1];
    const timelines = _summary?.players.map(v => v.timeline);
    setMilitaryLead(timelines[0].map((v, i) => ({ x: v.time, y: timelines.reduce((sum, timeline, playerIndex) => sum + timeline[i].score_military * weights[playerIndex], 0) })))


    if (_summary.players[0].result === "win") {
      setPlayer1Class(winnerClass)
      setPlayer2Class(loserClass)
    } else {
      setPlayer1Class(loserClass)
      setPlayer2Class(winnerClass)
    }



    setSummary(_summary)
    setAnnotations(_annotations)

    setIsReady(true)

  }, [data])

  const age2img = new Image(30, 30)
  age2img.src = "/age_icons/age_2_dark.png"
  const age3img = new Image(30, 30)
  age3img.src = "/age_icons/age_3_dark.png"
  const age4img = new Image(30, 30)
  age4img.src = "/age_icons/age_4_dark.png"

  return (
    <div className="postgame" style={{
      "--left-player-color": colors[match?.leftPlayer?.color]?.mainColor,
      "--left-player-color-secondary": colors[match?.leftPlayer?.color]?.secondaryColor,
      "--right-player-color": colors[match?.rightPlayer?.color]?.mainColor,
      "--right-player-color-secondary": colors[match?.rightPlayer?.color]?.secondaryColor
    }}>
      <link rel="stylesheet" type="text/css" href={`/themes/${config.cssTheme}`} />
      {isReady && !!data ?
        <div className='flags'>
          <div className='flags__left'>
            {/*<img className={`absolute -z-10 -mt-8 w-72`} src={`/flags/${summary?.players[0].civilization}.png`} alt="Civ" />*/}
          </div>
          <div className='flags__right'>
            {/*<img className={`absolute -z-10 -mt-8 w-72 right-0`} src={`/flags/${summary?.players[1].civilization}.png`} alt="Civ" />*/}
          </div>


          <div className="flex flex-row w-full justify-center">
            <div className='w-3/12 border-r-2'>
              <div className={`text-5xl text-center uppercase align-middle my-auto pt-4 ${player1Class}`}>{getTeamNameByPlayer(summary?.players[0].name)}</div>
              {/*<div className={`text-3xl pt-4 text-center ${player1Class}`}>{summary?.players[0].civilization.replace(/_/g, ' ').toUpperCase()}</div>*/}
            </div>

            <div className={`w-48 text-6xl text-center border-r-2 pt-4 ${player1Class}`}>{summary?.players[0].result.toUpperCase()}</div>

            <div className={`w-32 text-7xl text-center border-r-2 pt-2 ${player1Class}`}>{extraInfo.leftWins}</div>

            <div className="flex flex-col pt-2 text-center mx-auto">
              <div className="text-4xl text-white">{fancyTimeFormat(summary?.duration)}</div>
              <div className="text-2xl text-white">{summary?.mapName.toUpperCase()}</div>
            </div>

            <div className={`w-32 text-7xl text-center border-l-2 pt-2 ${player2Class}`}>{extraInfo.rightWins}</div>

            <div className={`w-48 text-6xl text-center border-l-2 pt-4 ${player2Class}`}>{summary?.players[2].result.toUpperCase()}</div>

            <div className='w-3/12 border-l-2'>
              <div className={`text-5xl text-center uppercase pt-4 ${player2Class}`}>{getTeamNameByPlayer(summary?.players[2].name)}</div>
              {/*<div className={`text-3xl pt-4 text-center ${player2Class}`}>{summary?.players[1].civilization.replace(/_/g, ' ').toUpperCase()}</div>*/}
            </div>

          </div>

          <hr className="mt-4 divider" />

          <div className='flex flex-row w-full'>
            <div className='flex flex-col w-1/2' >
              <div className='flex flex-col mx-auto w-9/12 pb-10 pt-16 '>
                {summary?.players.length === 4 ? <>
                  <Bar1002v2 name="TOTAL RESOURCES GATHERED" player1={summary?.players[0].totalResourcesGathered.total} player2={summary?.players[1].totalResourcesGathered.total} player3={summary?.players[2].totalResourcesGathered.total} player4={summary?.players[3].totalResourcesGathered.total} />
                  <Bar1002v2 name="FOOD" player1={summary?.players[0].totalResourcesGathered.food} player2={summary?.players[1].totalResourcesGathered.food} player3={summary?.players[2].totalResourcesGathered.food} player4={summary?.players[3].totalResourcesGathered.food} />
                  <Bar1002v2 name="WOOD" player1={summary?.players[0].totalResourcesGathered.wood} player2={summary?.players[1].totalResourcesGathered.wood} player3={summary?.players[2].totalResourcesGathered.wood} player4={summary?.players[3].totalResourcesGathered.wood} />
                  <Bar1002v2 name="GOLD" player1={summary?.players[0].totalResourcesGathered.gold} player2={summary?.players[1].totalResourcesGathered.gold} player3={summary?.players[2].totalResourcesGathered.gold} player4={summary?.players[3].totalResourcesGathered.gold} />
                  {
                    (summary?.players[0].totalResourcesGathered.stone !== 0 || summary?.players[1].totalResourcesGathered.stone !== 0 || summary?.players[2].totalResourcesGathered.stone !== 0 || summary?.players[3].totalResourcesGathered.stone !== 0) &&
                    <Bar1002v2 name="STONE" player1={summary?.players[0].totalResourcesGathered.stone} player2={summary?.players[1].totalResourcesGathered.stone} player3={summary?.players[2].totalResourcesGathered.stone} player4={summary?.players[3].totalResourcesGathered.stone} />
                  }
                </> : <></>}
              </div>

              <div className="overflow-x-auto mx-auto w-fit pt-64 mt-72 ml-16 absolute">
                <table className="w-full text-2xl text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  <thead className="text-xs text-gray-700 uppercase">
                    <tr>
                      <th scope="col" className="px-6 py-3"></th>

                      <th scope="col" className="text-2xl px-6 py-3 bg-gray-600 text-white">Max Vills</th>
                      {(summary?.players[0].maxTraders !== 0 || summary?.players[1].maxTraders !== 0 || summary?.players[2].maxTraders !== 0 || summary?.players[3].maxTraders !== 0) &&
                        <th scope="col" className="text-2xl px-6 py-3 bg-gray-600 text-white">Max Trade</th>
                      }
                      {(summary?.players[0].maxFishingShips !== 0 || summary?.players[1].maxFishingShips !== 0 || summary?.players[2].maxFishingShips !== 0 || summary?.players[3].maxFishingShips !== 0) &&
                        <th scope="col" className="text-2xl px-6 py-3 bg-gray-600 text-white">Max Fish Ships</th>
                      }
                      <th scope="col" className="text-2xl px-6 py-3 bg-gray-600 text-white">APM</th>
                      <th scope="col" className="text-2xl px-6 py-3 bg-gray-600 text-white">ECO Lost</th>
                    </tr>
                  </thead>
                  <tbody>
                    {summary?.players.length === 4 ?
                      <>
                        <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                          <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white bg-blue-500 flex flex-row align-middle">
                            <img className={`w-8 h-full aspect-auto right-0 object-cover pt-1 mr-2`} src={`/draftFlags/${summary?.players[0].civilization}.png`} alt="Civ" /> <h1>{summary.players[0].name}</h1>
                          </th>
                          <ScoreRow players={summary?.players} index={0} item="maxVillagers" />

                          {(summary?.players[0].maxTraders !== 0 || summary?.players[1].maxTraders !== 0 || summary?.players[2].maxTraders !== 0 || summary?.players[3].maxTraders !== 0) &&
                            <ScoreRow players={summary?.players} index={0} item="maxTraders" />
                          }
                          {(summary?.players[0].maxFishingShips !== 0 || summary?.players[1].maxFishingShips !== 0 || summary?.players[2].maxFishingShips !== 0 || summary?.players[3].maxFishingShips !== 0) &&
                            <ScoreRow players={summary?.players} index={0} item="maxFishingShips" />
                          }
                          <ScoreRow players={summary?.players} index={0} item="apm" />
                          <ScoreRow players={summary?.players} index={0} item="economyLost" />
                        </tr>

                        <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                          <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white bg-blue-400 flex flex-row align-middle">
                            <img className={`w-8 h-full aspect-auto right-0 object-cover pt-1 mr-2`} src={`/draftFlags/${summary?.players[1].civilization}.png`} alt="Civ" /> <h1>{summary.players[1].name}</h1>
                          </th>

                          <ScoreRow players={summary?.players} index={1} item="maxVillagers" />
                          {(summary?.players[0].maxTraders !== 0 || summary?.players[1].maxTraders !== 0 || summary?.players[2].maxTraders !== 0 || summary?.players[3].maxTraders !== 0) &&
                            <ScoreRow players={summary?.players} index={1} item="maxTraders" />}
                          {(summary?.players[0].maxFishingShips !== 0 || summary?.players[1].maxFishingShips !== 0 || summary?.players[2].maxFishingShips !== 0 || summary?.players[3].maxFishingShips !== 0) &&
                            <ScoreRow players={summary?.players} index={1} item="maxFishingShips" />}
                          <ScoreRow players={summary?.players} index={1} item="apm" />
                          <ScoreRow players={summary?.players} index={1} item="economyLost" />
                        </tr>


                        <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                          <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white bg-red-400 flex flex-row align-middle">
                            <img className={`w-8 h-full aspect-auto right-0 object-cover pt-1 mr-2`} src={`/draftFlags/${summary?.players[2].civilization}.png`} alt="Civ" /> <h1>{summary.players[2].name}</h1>
                          </th>
                          <ScoreRow players={summary?.players} index={2} item="maxVillagers" />

                          {(summary?.players[0].maxTraders !== 0 || summary?.players[1].maxTraders !== 0 || summary?.players[2].maxTraders !== 0 || summary?.players[3].maxTraders !== 0) &&
                            <ScoreRow players={summary?.players} index={2} item="maxTraders" />
                          }
                          {(summary?.players[0].maxFishingShips !== 0 || summary?.players[1].maxFishingShips !== 0 || summary?.players[2].maxFishingShips !== 0 || summary?.players[3].maxFishingShips !== 0) &&
                            <ScoreRow players={summary?.players} index={2} item="maxFishingShips" />
                          }
                          <ScoreRow players={summary?.players} index={2} item="apm" />
                          <ScoreRow players={summary?.players} index={2} item="economyLost" />
                        </tr>

                        <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                          <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white bg-red-500 flex flex-row align-middle">
                            <img className={`w-8 h-full aspect-auto right-0 object-cover pt-1 mr-2`} src={`/draftFlags/${summary?.players[3].civilization}.png`} alt="Civ" /> <h1>{summary.players[3].name}</h1>
                          </th>

                          <ScoreRow players={summary?.players} index={3} item="maxVillagers" />
                          {(summary?.players[0].maxTraders !== 0 || summary?.players[1].maxTraders !== 0 || summary?.players[2].maxTraders !== 0 || summary?.players[3].maxTraders !== 0) &&
                            <ScoreRow players={summary?.players} index={3} item="maxTraders" />}
                          {(summary?.players[0].maxFishingShips !== 0 || summary?.players[1].maxFishingShips !== 0 || summary?.players[2].maxFishingShips !== 0 || summary?.players[3].maxFishingShips !== 0) &&
                            <ScoreRow players={summary?.players} index={3} item="maxFishingShips" />}
                          <ScoreRow players={summary?.players} index={3} item="apm" />
                          <ScoreRow players={summary?.players} index={3} item="economyLost" />
                        </tr>


                      </> : <></>
                    }


                  </tbody>
                </table>
              </div>
            </div>

            <div className="charts flex flex-col justify-center pb-16">
              <div className="charts__military">
                <h1 className="charts__military__title charts__title">Military Value Lead</h1>
                <Scatter className=""
                  height={"355px"}
                  style={{ maxHeight: "355px" }}
                  options={{
                    maintainAspectRatio: false,
                    aspectRatio: 1,
                    animation: false,
                    legend: {
                      display: false
                    },
                    title: {
                      display: false
                    },
                    scales: {
                      x: {
                        min: 20,
                        ticks: {
                          stepSize: 60,
                          callback: (v) => v >= 30 ? ((v / 60).toString() + " min") : '',
                          color: 'white'
                        },
                        grid: {
                          color: 'rgba(255,255,255,.3)'
                        }
                      },
                      y: {
                        beginAtZero: true,
                        suggestedMax: 150,
                        suggestedMin: 150,
                        ticks: {
                          callback: (v) => (Math.abs(v)).toString(),
                          color: 'white',
                          font: { size: 20 }
                        },
                        grid: {
                          color: 'rgba(255,255,255,.3)'
                        }
                      }
                    },
                    plugins: {
                      legend: {
                        display: false
                      },
                    }
                  }}

                  data={{
                    datasets: [{
                      label: '',
                      type: 'line',
                      data: militaryLead,
                      borderColor: "black",
                      borderWidth: 1,
                      pointRadius: 0,
                      fill: {
                        target: 'origin',
                        below: 'rgb(240, 67, 67)',   // Area will be red above the origin
                        above: 'rgb(74, 136, 237)'    // And blue below the origin
                      }
                    }]
                  }}
                />
              </div>
              <div className="charts__economy">
                <h1 className="charts__economy__title charts__title">Economy Count</h1>
                <Scatter className=""
                  height={"355px"}
                  style={{ maxHeight: "355px" }}
                  options={{
                    maintainAspectRatio: false,
                    aspectRatio: 1,
                    animation: false,
                    legend: {
                      display: false
                    },
                    title: {
                      display: false
                    },
                    scales: {
                      x: {
                        min: 20,
                        ticks: {
                          stepSize: 60,
                          callback: (v) => v >= 30 ? ((v / 60).toString() + " min") : '',
                          color: 'white',
                        },
                        grid: {
                          color: 'rgba(255,255,255,.3)'
                        }
                      },
                      y: {
                        beginAtZero: true,
                        ticks: {
                          color: 'white',
                          font: { size: 20 }
                        },
                        grid: {
                          color: 'rgba(255,255,255,.3)'
                        }
                      }
                    },
                    plugins: {
                      legend: {
                        display: false
                      },
                      annotation: {
                        annotations: annotations
                      }
                    }
                  }}

                  data={{
                    datasets: [
                      {
                        label: '',
                        type: 'line',
                        data: summary?.players[3].timeline.map(v => ({ x: v.time, y: v.population_economy })),
                        borderColor: 'rgb(240, 67, 67)',
                        borderWidth: 4,
                        pointRadius: 0,
                      },
                      {
                        label: '',
                        type: 'line',
                        data: summary?.players[0].timeline.map(v => ({ x: v.time, y: v.population_economy })),
                        borderColor: 'rgb(74, 136, 237)',
                        borderWidth: 4,
                        pointRadius: 0,

                      },
                      {
                        label: '',
                        type: 'line',
                        data: summary?.players[1].timeline.map(v => ({ x: v.time, y: v.population_economy })),
                        borderColor: 'rgb(130, 177, 242)',
                        borderWidth: 4,
                        pointRadius: 0,
                      },
                      {
                        label: '',
                        type: 'line',
                        data: summary?.players[2].timeline.map(v => ({ x: v.time, y: v.population_economy })),
                        borderColor: 'rgb(245, 128, 128)',
                        borderWidth: 4,
                        pointRadius: 0,
                      },
                    ]
                  }}
                />
              </div>
            </div>
          </div>
          <div className='text-gray-100 text-right px-5 py-2 absolute end-0 bottom-0'>Data provided by aoe4world.com</div>
        </div>

        : <></>}

    </div>
  );

}
